var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('v-tabs',{attrs:{"mr-5":"","dark":"","color":"#ffbc00","background-color":"#01579b"}},[_c('v-tab',{staticClass:"font-weight-black"},[_vm._v("Notas Conductuales")]),_c('v-tab-item',[_c('NotasConductuales',{staticClass:"mt-2"})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }